import React from 'react'
import styled from 'styled-components'

import courseTheme from '../../constants/theme'
import LessonItem from './LessonItem'

const Wrapper = styled.div`
  margin-top: ${courseTheme.gutter};
`

function LessonList({ courseType, courseSlug, lessons, className }) {
  return (
    <Wrapper className={className}>
      {lessons.map((lesson, index) => (
        <LessonItem
          key={courseType === 'online' ? lesson.slug : index}
          courseType={courseType}
          courseSlug={courseSlug}
          {...lesson}
        ></LessonItem>
      ))}
    </Wrapper>
  )
}

export default LessonList
